<template>
  <!-- 推广管理 -->
  <div class="el-card  pd20">
    <!-- add---新增 -->
    <div class="box">
      <!--  -->
      <div class="search">
        <!--  -->
        <div class="search-gropu">
          用户昵称
          <el-input class="search-child" v-model="nickname" placeholder="请输入用户昵称"></el-input>
        </div>
        <div class="search-gropu">
          推广员等级
          <el-select class="search-child" v-model="level" placeholder="请选择等级" clearable>
            <el-option label="无" :value="-1">无</el-option>
            <el-option v-for="(item,index) in rules" :key="index" :label="item.role" :value="item.level">{{item.role}}</el-option>
          </el-select>
        </div>
        <!--  -->
        <div class="search-gropu">
          加入时间
          <el-date-picker class="buy-time" v-model="buy_time" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </div>
        <el-button type="primary" @click="pullData" size="medium">搜索</el-button>
        <el-button type="primary" @click="exportExcel" size="medium">导出订单</el-button>
      </div>
    </div>
    <!--  -->
    <div class="el-card  pd20 content">
      <el-table :data="list" border style="width: 100%" @sort-change="changeTableSort">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column label="用户昵称">
          <template slot-scope="scope">
            <div class="userinfo">
              <img :src="scope.row.headimgurl" alt="">
              <el-popover trigger="hover" placement="top">
                {{scope.row.nickname}}
                <div slot="reference" class="name-wrapper">
                  <span class="text-ellipsis">{{scope.row.nickname}}</span>
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="role" label="推广员等级"> </el-table-column>
        <el-table-column label="上级推广员">
          <template slot-scope="scope">
            <div class="userinfo" v-if="scope.row.parent_uid != null">
              <img :src="scope.row.parent_headimgurl" alt="">
              <el-popover trigger="hover" placement="top">
                {{scope.row.parent_nickname}}
                <div slot="reference" class="name-wrapper">
                  <span class="text-ellipsis">{{scope.row.parent_nickname}}</span>
                </div>
              </el-popover>
            </div>
            <div v-else>无</div>
          </template>
        </el-table-column>
        <el-table-column prop="buy_count" label="购买人数" :sortable="'custom'"> </el-table-column>
        <el-table-column prop="view_count" label="查看人数" :sortable="'custom'"> </el-table-column>
        <el-table-column prop="total_fee" label="累计收益" :sortable="'custom'"></el-table-column>
        <el-table-column prop="create_time" label="加入时间" width="180"></el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-view" @click="view(scope.$index, scope.row)" circle></el-button>
            <el-button type="warning" size="mini" icon="el-icon-edit" @click="updateHandle(scope.$index, scope.row)" circle></el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeHandle(scope.$index, scope.row)" circle></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="修改等级" :visible.sync="dialogVisible" width="30%">
        <div class="update">
          修改等级：
          <el-select class="search-child" v-model="update_level">
            <el-option v-for="(item,index) in rules" :key="index" :label="item.role" :value="item.level">{{item.role}}</el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="setLevel(uid,update_level)">确 定</el-button>
  </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination class="pages" :page-sizes="[25, 50, 75, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pages.size" :current-page="pages.page" background layout="sizes,prev, pager, next" :total="pages.count">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  promoterList,
  promoterExport,
  getRule,
  setLevel
} from "@/api/operating";
import {
  exportExcel
} from "@u/tools";
export default {
  data() {
      return {
        pages: {},
        list: [],
        nickname: '',
        buy_time: [],
        obj: {},
        rules: [],
        level: '',
        update_level: '',
        dialogVisible: false,
        uid: '',
        asc: false,
        sort: ''
      }
    },
    methods: {
      // 排序
      changeTableSort(column) {
        //获取字段名称和排序类型
        this.sort = column.prop;
        let sortingType = column.order;
        //按照降序排序
        if(sortingType == "descending"){
            this.asc = false
        }
        //按照升序排序
        else{
            this.asc = true
        }
        this.pullData();
      },
      // 导出到excel
      exportExcel() {
        let h = ['用户昵称', '用户头像', '推广员等级', '上级推广员昵称', '上级推广员头像', '购买人数', '查看人数', '累计收益', '加入时间'];
        let b = ['nickname', 'headimgurl', 'role', 'parent_nickname', 'parent_headimgurl', 'buy_count', 'view_count', 'total_fee', 'create_time'];

        promoterExport(this.obj).then((res) => {
          let list = res.list; //把data里的tableData存到list
          exportExcel(h, b, list, '推广员')
        })
      },
      view(index, row) {
        this.$router.push({
          path: '/main/marketing_details',
          query: {
            id: row.uid
          }
        });
      },
      // 修改等级
      updateHandle(index, row) {
        this.dialogVisible = true;
        this.uid = row.uid;
      },
      // 清退等级
      removeHandle(index, row) {
        this.$confirm('<h3>若清退该推广员，该用户不再是推广员，下级客户会全部解绑，确定要清退么?</h3><h4>*该用户可根据规则，再次成为推广员</h4>', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.setLevel(row.uid, -1);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消清退'
          })
        });
      },
      setLevel(uid, level) {
        setLevel({
          uid: uid,
          level: level
        }).then((data) => {
          if (data.error > 0) {
            this.$message(data.msg);
            return
          }
          this.$message({
            message: level == -1 ? '清退成功！' : '修改成功！',
            type: 'success'
          });
          if (level != -1) {
            this.dialogVisible = false;
          } else {
            this.update_level = ''
          }
          this.pullData();
        });
      },
      // 调整每页显示条数
      handleSizeChange(val) {
        this.pages.size = val;
        this.pullData();
      },
      // 触发分页
      handleCurrentChange(val) {
        this.pages.page = val;
        this.pullData();
      },
      pullData() {
        this.$showLoading();
        this.obj = {
          page: Object.keys(this.pages).length > 0 ? this.pages.page : 1, //页码，默认1
          size: Object.keys(this.pages).length > 0 ? this.pages.size : 25 //每页数量，默认25
        };
        // 判断如果有值为真的情况下传参,否则不传
        if (this.nickname) {
          this.obj['nickname'] = this.nickname;
        }
        if (this.level) {
          this.obj['level'] = this.level;
        }
        if (this.buy_time && this.buy_time.length > 0) {
          this.obj['start_time'] = this.buy_time[0]; //开始时间
          this.obj['end_time'] = this.buy_time[1]; //结束时间
        }
        // 排序
        if (this.sort) {
          this.obj['sort'] = this.sort;
          this.obj['asc'] = this.asc;
        }
        promoterList(this.obj).then((data) => {
          this.list = data.list;
          this.pages = data.pager;
          this.$hideLoading();
        }).catch((err) => {
          this.$hideLoading();
        });
      },
      // 获取等级
      getRule() {
        getRule().then((data) => {
          this.rules = data.rules;
          this.$hideLoading();
        }).catch((err) => {
          this.$hideLoading();
        });
      }
    },
    created() {
      this.pullData();
      this.getRule();
    }
}
</script>
<style lang="scss" scoped>
.headimgurl {
  width: 100px;
  height: 100px;
}

.box {
  margin-bottom: 20px;
}

.content {
  padding: 20px;
}

.userinfo {
  display: flex;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
  span {
    width: 44px;
    display: block;
  }
}

.pages {
  text-align: right;
  margin-top: 30px;
}

.search {
  display: flex;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
}

.search-child {
  margin-left: 20px;
  width: 150px;
}

.buy-time {
  margin-left: 20px;
  width: 220px;
}
</style>
<style lang="scss">
.buy-time input {
  background-color: transparent !important;
  width: 60% !important;
}

.el-dialog {
  background-color: #fff !important;
}

.new-style .el-dialog .el-dialog__title {
  color: #333 !important;
}
</style>
